var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.895 13.895C.885 13.895 0 13.011 0 12V9.6c0-.252 0-.379.126-.631l1.516-3.79C2.274 3.537 3.916 2.4 5.81 2.4h2.527l-.632 1.264H5.81c-1.263 0-2.4.757-2.905 2.02L1.39 9.475v2.4c0 .379.253.631.632.631v1.39h-.126z",
    fill: "var(--color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.422 16.42a3.127 3.127 0 01-3.158-3.159 3.127 3.127 0 013.158-3.157 3.127 3.127 0 013.157 3.157 3.127 3.127 0 01-3.157 3.158zm0-5.053c-1.011 0-1.895.884-1.895 1.894 0 1.01.884 1.895 1.895 1.895 1.01 0 1.894-.884 1.894-1.895 0-1.01-.884-1.894-1.894-1.894z",
    fill: "var(--color-secondary)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.842 12.631h1.263c.38 0 .632-.252.632-.631V3.158c0-1.01-.884-1.895-1.895-1.895H10.737c-1.01 0-1.895.884-1.895 1.895v9.473h6.947v1.264H8.212c-.38 0-.632-.253-.632-.632V3.158A3.127 3.127 0 0110.737 0h10.105A3.127 3.127 0 0124 3.158V12c0 1.01-.884 1.895-1.895 1.895h-1.263V12.63z",
    fill: "var(--color-secondary)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.315 16.42a3.127 3.127 0 01-3.158-3.159 3.127 3.127 0 013.158-3.157 3.127 3.127 0 013.158 3.157 3.127 3.127 0 01-3.158 3.158zm0-5.053c-1.01 0-1.895.884-1.895 1.894 0 1.01.885 1.895 1.895 1.895s1.895-.884 1.895-1.895c0-1.01-.884-1.894-1.895-1.894z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.d6aa957258f39b99b83b3246e72f2d09.svg";
export { ForwardRef as ReactComponent };